"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const cases = [{
  id: 1,
  label: "SERVICIOS AEROPORTUARIOS B2B",
  description: "Ciclo de cuentas por cobrar reducido de 20-25 días a 2-3. Sesenta y un usuarios activos en seis unidades de negocio."
}, {
  id: 2,
  label: "TURISMO Y EXPERIENCIAS · FLOTILLA MEDIANA",
  description: "72 vehículos en operación. Eliminación de captura manual diaria. Reportes ejecutivos en tiempo real."
}];
export default function LoQueHemosConstruido() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="loquehemosconstruido" className="bg-background py-24 px-6 md:px-12 lg:px-24">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="font-serif font-normal text-4xl md:text-5xl lg:text-6xl text-foreground mb-16 leading-tight">
          Lo que hemos construido.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-16">
          {cases.map((item, i) => <Card key={item.id} data-index={i} className="bg-transparent border border-border rounded-sm p-8 md:p-10 flex flex-col h-full">
              <div className="font-mono text-xs tracking-widest uppercase text-primary mb-6">
                {item.label}
              </div>
              <p className="font-sans text-foreground text-lg leading-relaxed">
                {item.description}
              </p>
            </Card>)}
        </div>

        <div className="flex justify-center">
          <Button asChild variant="link" className="font-sans text-base text-foreground hover:text-primary h-auto p-0">
            <Link to="https://fulcro.mx/sobre/" className="inline-flex items-center group">
              Ver más en Sobre Fulcro
              <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}